import React, { FC } from 'react';

import { BudgetsTrackingTable } from '../../components/tracking/table';

export const BudgetsTracking: FC<Record<string, unknown>> = () => (<BudgetsTrackingTable />);
